/**
 * Cookie Consents scripts
 *
 * Scripts from SEOmatic are injected IF the consent is given. The consent must be named performance for the SEOmatic scripts
 * Note: the limitation of this is that GoogleTagManager itself is injected if performance is given but scripts that
 * may be loaded by GTM are not filtered out - all will be run IF GTM is allowed.
 *
 */
(() => {
  'use strict';

    const COOKIE_NAME = 'cookie_consent_v2'

    const GRAPHQL_TOKEN = 'Bearer lLe9ia0zcPuHJgjC3Ve_vEDmdkIBar4o'

    // Expire the legacy raw-JSON cookie so it stops being sent to (and blocked by) the WAF.
    const LEGACY_COOKIE_NAME = 'cookie_consent'
    document.cookie = `${LEGACY_COOKIE_NAME}=; path=/; max-age=0`

    const getConsent = () => {
        const match = document.cookie.match(new RegExp('(^| )' + COOKIE_NAME + '=([^;]+)'))
        if (!match) return null
        try {
            // Value is base64-encoded JSON; a malformed/tampered value is treated as "no consent".
            return JSON.parse(atob(decodeURIComponent(match[2])))
        } catch {
            return null
        }
    }

    const setConsent = (consent: any, container: HTMLElement) => {
        document.cookie = `${COOKIE_NAME}=${encodeURIComponent(btoa(JSON.stringify(consent)))}; path=/; max-age=31536000`
        container.classList.remove('active')
    }

  /**
   * Handle accepting cookies
   */
  const handleAcceptAll = (cookieGroups: any, container: HTMLElement) => {
      const consent = Object.fromEntries(
          Object.keys(cookieGroups).map(key => [key, true])
      )
      setConsent(consent, container)
  }

    /**
     * Handle rejecting cookies
     */
  const handleRejectAll = (cookieGroups: any, container: HTMLElement) => {
        const consent = Object.fromEntries(
            Object.keys(cookieGroups).map(key => [key, false])
        )
        setConsent(consent, container)
  }

    const getSeoScripts = async () => {
        const query = `{
          seomatic(uri: "/", siteId: 1, environment: live, asArray: true) {
            metaScriptContainer
          }
        }`

        const response = await fetch("/actions/graphql/api", {
            method:  "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "Authorization": GRAPHQL_TOKEN
            },
            body: JSON.stringify({ query }),
        })
            .then(res => res.json())
            .then(data => {
                return data.data
            })
        ;

        if (response.seomatic) {
            return JSON.parse(response.seomatic.metaScriptContainer)
        } else {
            return {}
        }
    };

    const consent = getConsent()


    if (consent?.analytics) {
        // Insert custom analytics scripts here

    }

    // Get the SEOmatic scripts
    getSeoScripts().then(metaContainers => {

        const analyticsScripts = ['gTag', 'googleTagManager', 'facebookPixel', 'linkedInInsight', 'hubSpot', 'pinterestTag', 'fathom', 'matomo', 'plausible', 'googleAnalytics' ]

        // For each analytics script if the consent is given, insert the script
        Object.entries(metaContainers).forEach(([key, container]: [string, any]) => {
            // If consent is given to `performance` then insert the scripts
            if (analyticsScripts.includes(key) && container.script && consent?.performance) {
                const newScript = document.createElement('script')
                newScript.textContent = container.script
                document.head.appendChild(newScript)
            }
            // We skip noscript since JS is already running
        })
    })

    /**
     * Other scripts that are injected directly should be included here is the consent matches
     *
     * Example:
     *
     * if (consent?.advertising) {
     *     const newScript = document.createElement('script')
     *     newScript.textContent = 'console.log("Performance consent given")'
     *     document.head.appendChild(newScript)
     * }
     */


    // The `afterBlitzInjectAll` event is triggered after all dynamic content tags are injected
    document.addEventListener('afterBlitzInjectAll', function (event) {

        // Find the consent container
        const consentContainer = document.querySelector('[data-consents]') as HTMLElement

        if (consentContainer) {

            setTimeout(() => consentContainer.classList.add('active'), 500)

            const cookieGroups = JSON.parse(consentContainer.dataset.consents ?? '{}')

            const buttons = consentContainer.querySelectorAll('[data-consent-button]')

            const preferencesButton = consentContainer.querySelector('[data-consent-preferences]') as HTMLButtonElement

            const options = consentContainer.querySelector('.consent-options') as HTMLElement

            // Create event listeners for each consent button
            buttons.forEach(button => {

                button.addEventListener('click', () => {
                    const consentType = button.getAttribute('data-consent-button')

                    if (consentType === 'accept') {
                        handleAcceptAll(cookieGroups, consentContainer)
                    } else if (consentType === 'reject') {
                        handleRejectAll(cookieGroups, consentContainer)
                    } else if (consentType === 'manage') {
                        options.classList.add('open')
                    }
                })

            })

            if (preferencesButton) {
                preferencesButton.addEventListener('click', () => {
                    const consent: Record<string, boolean> = {}

                    options.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach(checkbox => {
                        if (checkbox.name in cookieGroups) {
                            consent[checkbox.name] = checkbox.checked
                        }
                    })

                    setConsent(consent, consentContainer)
                })
            }

        }
    });

})();
